(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["usp-block"] && !Shopify.designMode) return;
  try {
    class UspCard extends HTMLElement {
    constructor() {
      super();

      if (window.innerWidth <= 1024) return;

      this.cta = this.querySelector('.usp-card__cta');
      if (!this.cta) return;

      this.addEventListener('mouseenter', () => {
        const width = this.cta.scrollWidth + 20;
        this.cta.style.setProperty('--cta-width', `${width}px`);
        this.cta.classList.add('active');
      });

      this.addEventListener('mouseleave', () => {
        this.cta.classList.remove('active');
      });
    }
  }

  customElements.define('usp-card', UspCard);
  } catch(e) { console.error(e); }
})();

})();
